export * from './interfaces/pagination-config.interface';
export * from './interfaces/pagination-event.interface';
export * from './classes/pagination';
export * from './pagination.component';
